<template lang="">
    <Modal id="downgrade-warn" :show-footer="false" :show-title="false" @cancel="cancel">
        <div class="content">
            <div class="upgrade-svg">
                <Warn />
            </div>
            <div class="title">{{ $t("message.downgradeWarnTitle") }}</div>
            <div class="description">
                <slot />
            </div>
            <div class="subbutton" @click="goShow">{{ $t("message.downgradeWarnForward") }}</div>
        </div>
    </Modal>
</template>
<script>
import Modal from "./common/Modal2.vue";
import Warn from "./svg/WarnPeople.vue";

export default {
    name: "UpgradeNeeded",
    components: {
        Modal,
        Warn,
    },
    methods: {
        goShow() {
            this.$emit("forward");
        },
        cancel() {
            this.$emit("close");
        },
    },
};
</script>
<style lang="scss">
#downgrade-warn {
    .content {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;

        .upgrade-svg {
            width: 100%;
            height: 100%;

            svg {
                width: 80%;
                height: 40%;
            }
        }

        .title {
            font-size: 26px;
            font-weight: bold;
            margin-top: 20px;
            margin-bottom: 15px;
        }

        .description {
            font-size: 16px;
        }

        .subbutton {
            padding: 10px 30px;
            background: rgb(236, 75, 29);
            border-radius: 4px;
            font-size: 16px;
            cursor: pointer;
            color: white;
            margin-top: 15px;
        }
    }
}
</style>
